import { useEffect } from 'react';
import { Box } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ADVISOR_ROUTES } from '../../routes/routeConstants';
import { TermTabType } from '../../common/constants';
import { useFundingNavigatorTabs, useFundingTermScope, useAppSelector } from '../../common/hooks';
import { Typography } from '../../components/atoms/Typography/Typography';
import { PrimaryTabs } from '../../components/molecules';
import MappingGuideLink from '../../containers/goals-inline-flow2/MappingGuideLink';
import { FundingNavigatorTermContainer } from '../../components/organisms/FundingNavigatorTermContainer';
import { selectEwsResponses } from '../../features/ews';
import { ContainerBox } from '../../themes/styles/common';

const FundingNavigatorStep = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { selectedTermIndex, handleGoalTermTabChange, goalCountsByTerm } = useFundingNavigatorTabs();
    const { isMultiPortfolioTenant, durationKey: currentDurationKey } = useFundingTermScope(selectedTermIndex);
    const currentEwsData = useAppSelector((state) => selectEwsResponses(state)?.[currentDurationKey]);
    const isLoading = currentEwsData?.loading === true;

    useEffect(() => {
        if (location.pathname !== ADVISOR_ROUTES.FUNDING_NAVIGATOR)
            navigate(ADVISOR_ROUTES.FUNDING_NAVIGATOR, { replace: true });
    }, []);

    return (
        <ContainerBox>
            <>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginBottom: '32px',
                        ...(!isMultiPortfolioTenant && { minHeight: '36px' })
                    }}
                >
                    <Typography
                        variant="body.small"
                        label={isLoading ? 
                            <Trans
                                i18nKey={`FUNDING_NAVIGATOR_SUBTITLE`}
                                components={{ b: <b /> }}
                            /> : t('FUNDING_NAVIGATOR_SUBHEADER')}
                        color="semantic.text.default"
                        sx={{ fontSize: '14px', fontWeight: 400, lineHeight: '19px' }}
                    />
                    {!isMultiPortfolioTenant && <MappingGuideLink />}
                </Box>
                {isMultiPortfolioTenant && (
                    <PrimaryTabs
                        ftdsBadge
                        value={selectedTermIndex}
                        onChange={handleGoalTermTabChange}
                        tabItems={[
                            {
                                key: TermTabType.SHORT,
                                label: t('SHORT'),
                                count: goalCountsByTerm[TermTabType.SHORT]
                            },
                            {
                                key: TermTabType.MEDIUM,
                                label: t('MEDIUM'),
                                count: goalCountsByTerm[TermTabType.MEDIUM]
                            },
                            {
                                key: TermTabType.LONG,
                                label: t('LONG'),
                                count: goalCountsByTerm[TermTabType.LONG]
                            }
                        ]}
                        showMappingGuideLink
                    />
                )}
                <FundingNavigatorTermContainer selectedTermIndex={selectedTermIndex} />
            </>
        </ContainerBox>
    );
};

export default FundingNavigatorStep;
